import { Collapse } from '@mui/material';

import { GDMCollapseComponent } from './GDMCollapse.type';

/* TODO: Implement component using GDM default design */
const GDMCollapse: GDMCollapseComponent = props => <Collapse {...props} />;

export default GDMCollapse;
